module.exports = __webpack_public_path__ + "media/images/maroc-4cb689f9c6df8321ce6135650bbf8679.svg";